import { Popconfirm, Space } from 'antd';
import dayjs from 'dayjs';
// import { userInfo } from 'os';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Component = (props: any) => {
  const {
    source,
    del_confirm,
    setCurInfo,
    setStatus,
    setCurType,
    userInfo
  } = props;
  const history = useNavigate();
  console.log(source);
  return (
    <div className='indexTable mt2' style={{ marginBottom: '2rem' }}>
      <table>
        <thead>
          <tr>
            <th>项目名称</th>
            <th>项目描述</th>
            <th>流程总数</th>
            <th>计算任务</th>
            <th>创建日期</th>
            <th>创建人</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          {source.map((item: any, index: any) => {
            return <tr key={index}>
              <td className='tabelImg'
                onClick={() => history(`/project/home/view?k=${item.id}`)}
              >
                <div>
                  <div className='itemPic'><div className='itemPicInner'><img src={item.thumbnail_url} alt="" /></div></div>
                </div>
                <div className='itemName'>{item.name}</div>
              </td>
              <td className='itemDesc'>{item.description}</td>
              <td className='itemFlowTotal'>{item.flow_count}</td>
              <td className='itemTaskTotal'>{item.job_count}</td>
              <td>{dayjs(item.created_at).format('YYYY-MM-DD')}</td>
              <td>{userInfo.username}</td>
              <td className='item_action_td'>
                <div className='item_action_c'>
                  <div className="item_action">
                    {/* <div className="sp_icon sp_icon_view" title="查看"
                      onClick={() => history(`/project/home/view?k=${item.id}`)}
                    /> */}
                    <div className="sp_icon sp_icon_edit" title="修改"
                      onClick={() => {
                        setCurType('edit');
                        setCurInfo(item);
                        setStatus(true);
                      }}
                    />
                    <Popconfirm
                      title="确定删除该项目？"
                      description="删除后不可恢复！"
                      onConfirm={() => del_confirm(item.id)}
                      // onCancel={cancel}
                      okText="是"
                      cancelText="否"
                    >
                      <div className="sp_icon sp_icon_delete" title="删除" />
                    </Popconfirm>
                  </div>
                </div>

              </td>
            </tr>
          })}
        </tbody>
      </table>
    </div>
  );
};


export default Component;